import { Box, Button, customStyled, Flex, Text } from '@mafc/trolly';

export const SubTitle = customStyled(Box)(({ theme: { fontSizes, fontWeights } }) => ({
  fontWeight: fontWeights[3],
  fontSize: fontSizes[2],
  textAlign: 'center',
  margin: '0 auto 16px',
}));

export const TotalItems = customStyled(Text.Caption)(({ theme: { fontWeights } }) => ({
  fontWeight: fontWeights[6],
}));

export const OOSEntryRow = customStyled(Flex)(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '24px',
}));

export const OOSItems = customStyled(Box)(() => ({
  padding: '16px 16px 90px',
}));

export const ProductName = customStyled(Box)(({ theme: { fontSizes, fontWeights } }) => ({
  fontWeight: fontWeights[3],
  fontSize: fontSizes[2],
}));

export const RemoveAndCheckoutButton = customStyled(Button)`
  bottom: 16px;
  font-weight: ${props => props.theme.fontWeights[6]};
  font-size: ${props => props.theme.fontSizes[2]}px;
  left: 16px;
  position: absolute;
  right: 16px;
  text-transform: none;
  @media (min-width: ${props => props.theme.breakpoints[1]}) {
    position: initial;
    width: 100%;
  }
`;
